









# import settings from '@/settings'

export default {
    name: 'ages_pyramid'

    props: {
        datas: {
            type: Object
            required: true
        }
    }

    watch:
        datas: (value)->
            # console.log "WATCH AGES", value
            women_datas = []
            for k,v of @datas.f.percentages
                women_datas.push(-v)
            @ages_pyramid_options.series[0].data = women_datas
            @ages_pyramid_options.series[0].name = 'Femme (moyenne '+value.f.average+' ans)'
            men_datas = []
            for k,v of @datas.h.percentages
                men_datas.push(v)
            @ages_pyramid_options.series[1].data = men_datas
            @ages_pyramid_options.series[1].name = 'Homme (moyenne '+value.h.average+' ans)'

    data: ()->
        self = @
        return {
            ages_pyramid_options: {
                chart: {
                    type: "bar"
                },
                title: false,
                xAxis: [
                    {
                        categories: ["15 - 20","21 - 25","26 - 30","31 - 35","36 - 40","41 - 45","46 - 50","51 - 55","56 - 60","61+"],
                        reversed: false,
                        labels: {
                            step: 1
                        }
                    },
                    { # mirror axis on right side
                        categories: ["15 - 20","21 - 25","26 - 30","31 - 35","36 - 40","41 - 45","46 - 50","51 - 55","56 - 60","61+"],
                        opposite: true,
                        reversed: false,
                        linkedTo: 0,
                        labels: {
                            step: 1
                        }
                    }
                ],
                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        formatter: ()->
                            return Math.abs(this.value) + '%'
                    }
                },
                plotOptions: {
                    series: {
                        stacking: 'normal',
                        pointStart: 0
                    }
                },
                tooltip: {
                    formatter: ()->
                        if self.datas.f?
                            gender = 'f'
                            if this.colorIndex == 1
                                gender = 'h'
                            return '<b>' + this.series.name + ', âge ' + this.point.category + '</b><br/>' +
                            'Nombre: ' + self.datas[gender]['count'][this.series.xAxis.categories.indexOf(this.key)]
                },
                series: [
                    {
                        name: '',
                        data: []
                    },
                    {
                        name: '',
                        data: []
                    }
                ]
            }
        }

    # beforeMount: ()->
    #     console.log "AGES DATAS ", @datas
        # if @datas.f?
        #     women_datas = []
        #     for k,v of @datas.f.percentages
        #         women_datas.push(-v)
        #     @ages_pyramid_options.series[0].data = women_datas
        #     men_datas = []
        #     for k,v of @datas.h.percentages
        #         men_datas.push(v)
        #     @ages_pyramid_options.series[1].data = men_datas
}

